<div class="labels-add">
  <!-- button: add as a new tag-->
  <!--<span>We could not find any tags, </span> -->
  <core-helpers-forms-button-icon [text]="buttonText" [icon]="''" (click)="showCategories = !showCategories"></core-helpers-forms-button-icon>
  <!-- floating list of categories -->
  <div class="labels-categories-selector">
    <div class="labels-categories-fake-combo" [hidden]="categories.length == 0 || !showCategories">

      <div class="labels-categories-fake-combo-item" [hidden]="input == ''" *ngFor="let cat of categories">
        <span class="" (click)="select(cat)">... as <em>{{cat.name}}</em></span>
      </div>
      <!-- <div class="labels-categories-fake-combo-item" (click)="showCategories = !showCategories" [hidden]="input != ''">
        <h4 class=""><em>WRITE A TAG NAME</em></h4>
      </div> -->
    </div>
  </div>
</div>
